module.exports = __webpack_public_path__ + "paroquia.jpg?cfc9999b0892bcd6ba1f80163932fdcd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/paroquia.jpg
// module id = 144
// module chunks = 0